export default "<div fxHide.xs class=\"subtitle subtitle-3 button\" (click)=\"back()\">BACK</div>\n";